import { Store } from "#iso/pages/+store";
import { PageContext } from "vike/types";

export default (context: PageContext) => {
  const {
    store: { pages },
    routeParams: { section },
  } = context;
  const page = pages.find((p) => p.handle == (section || "qna"));
  const landscape =
    page?.images?.find((b) => b.url.includes("Landscape")) ||
    page?.images
      ?.slice()
      .sort((b, a) => a.width / a.height - b.width / b.height)[0];
  return {
    title: `${page.title} - Ignis Immensus`,
    description: page.body
      .replace(/<p>/g, "")
      .replace(/<\/p>/g, "\n\n")
      .replace(/<[^>]*>/g, "")
      .trim(),

    image:
      landscape?.url ||
      "https://cdn.shopify.com/s/files/1/0774/8534/3022/files/Composition-1-CenterCenter.jpg",
  };
};
